export const COUNTRY_MODEL = "country";

const countryModel = {
  countryName: "",
  currencyCode: ""
};

export default countryModel;
